import type { CameraConstraints, CameraProvider } from '../../core/camera/cameraProvider';

export const browserCameraProvider: CameraProvider = {
  async start(constraints = {}) {
    if (!navigator.mediaDevices?.getUserMedia) {
      throw new Error('Kamera tidak didukung di browser ini');
    }

    return navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: constraints.facingMode ?? 'environment',
        width: { ideal: constraints.width ?? 1280 },
        height: { ideal: constraints.height ?? 720 },
      },
      audio: false,
    });
  },

  stop(stream) {
    if (stream instanceof MediaStream) {
      stream.getTracks().forEach(track => track.stop());
    }
  },
};
